import { Question, WithContext } from 'schema-dts';
import { Faq, Product } from 'src/types';

export function faqPage(product: Product): WithContext<Question>[] {
  return product?.faqs?.filter(Boolean).map(f => faqSchema(f as Faq)) || [];
}

export function faqSchema(faq: Faq): WithContext<Question> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Question',
    name: faq.question!,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer!,
    },
  };
}
